import React, { useMemo, useState } from 'react'
import {
  CircleIcon
} from 'packages/wimap/Indoor/SVGs'
import { useMap } from 'packages/wimap/Indoor/IndoorProvider'
import { MarkerContainer } from 'packages/wimap/Indoor/Markers/styles'
import { Label, Chip } from 'packages/wimap/Indoor/Markers'

import { Device as DeviceType } from '../types'
import { useAccessPointZonesContext } from '../AccessPointZonesContext'
import DisableDevice from '../Sidebar/DisableDevice'

const Marker = ({
  device
}) => {
  const [deviceToDisabled, setDeviceToDisabled] = useState<DeviceType | null>(null)
  const { onDeviceOver, deviceHovered, apiActions } = useAccessPointZonesContext()
  // @ts-expect-error not ts
  const { convertPosRealToMap, iconSize, transformWrapperState } = useMap()


  const position = useMemo(() => {
    const { x, y } = convertPosRealToMap(device.position)
    return { x, y }
  }, [device, convertPosRealToMap])

  return (
    <>
      <MarkerContainer
        key={`${device.uuid}`}
        id={device.uuid}
        onClick={() => console.log('onClick')}
        viewBox={`0 0 ${iconSize * 2.5} ${iconSize * 2.5}`}
        width={(iconSize / transformWrapperState.scale) * 2.5}
        height={(iconSize / transformWrapperState.scale) * 2.5}
        {...position}
      >
        {device.markers && device.markers.map(
          ({ id, icon, colors }) =>
            <CircleIcon
              key={id}
              hovered={deviceHovered?.uuid === device.uuid}
              iconSize={iconSize}
              selected={!device.radio_enabled}
              icon={icon}
              pulse={apiActions.uuids.includes(device.uuid)}
              enabled={device.radio_enabled}
              colors={colors}
              onClick={async () => {
                if (device.radio_enabled && device.connected_stations > 0) {
                  setDeviceToDisabled(device)
                } else {
                  await apiActions.update({
                    devices: [device],
                    enabled: !device.radio_enabled,
                    scope: 'device',
                    source: 'floor_plan'
                  })
                }
              }}
              onMouseEnter={() => onDeviceOver(device)}
              onMouseLeave={() => onDeviceOver(null)}
            />
        )}
      </MarkerContainer>
      {
        Boolean(deviceToDisabled) && (
          <DisableDevice onClose={() => setDeviceToDisabled(null)} device={deviceToDisabled as DeviceType} source="floor_plan" />
        )
      }
    </>
  )
}

const Device = ({ device }) => {

  return (
    <>
      <Marker device={device} />
      <Label device={device} chipColor={null} />
      {
        device.radio_enabled && device.connected_stations > 0 && (
          <Chip device={device} />
        )
      }
    </>
  )
}

export default Device